<template>
  <v-container fluid ma-0 pa-0 px-4>
    <PageHeader
      title="Metrics"
      subtitle="Create, update or delete Metrics that are used on Metrics
            Dashboards."
    ></PageHeader>

    <v-flex xs12 pt-4>
      <v-flex xs12 v-for="(metric, index) in metrics" :key="index">
        <metric
          :metric="metric"         
        >
        </metric>
      </v-flex>
      <v-btn
        v-show="addMetricButton"
        v-on:click="addMetric()"
        class="ml-0 mt-0"
        color="secondary"
      >
        Add a Metric
      </v-btn>
      <metric-form :addMetricForm="addMetricForm" :metric=newMetric v-on:metric-added="metricAdded()" v-on:metric-cancelled="metricAdded()"></metric-form>
    </v-flex>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import Metric from "./Metric";
import MetricForm from "./MetricForm.vue";
import PageHeader from "@/components/PageHeader.vue";

export default {
  name: "Metrics",
  components: { MetricForm, PageHeader, Metric },
  computed: {
    ...mapState({
      metrics: (state) => state.metrics.all,
      caseTypes: (state) => state.caseTypes.all,
    }),
  },
  methods: {
    addMetric() {
      this.addMetricForm = true;
      this.addMetricButton = false;
    },
    metricAdded() {
      this.addMetricForm = false;
      this.addMetricButton = true;
      this.newMetric = {type: "Case Property", intermediateStateIds: []}
    }
  },
  data: () => {
    return {
      addMetricButton: true,
      addMetricForm: false,
      showDeleteDialog: false,
      newMetric: {type: "Case Property", intermediateStateIds: []}
    };
  },    
};
</script>
